import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {startLogin, startLogout} from '../actions/auth';

export const Header = (props) => {
    const startLogout = props.startLogout;
    return (
        <header className="header">
            <div className="content-container">
                <div className="header__content">
{/*
                    <Link className="header__title" to="/dashboard">
                    </Link>
                    <Link className='nav__link__white' to='/admin'>admin</Link>
                    <button className='button--link--white' onClick={startLogout}>logout</button>
*/}
                </div>
            </div>
        </header>
    );
};

const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
});

export default connect(undefined, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js